import { SaleCategory } from '../menu/item.types';

// ================ FRONTEND TYPES ================
export interface ICreateTipShare {
  name: string | undefined;
  effectiveDate?: string;
  shareBasedOn?: string;
  percentage?: number;
  contributors: Option[];
  recipients: Option[];
}

interface Option {
  value: number | any;
  label: string;
}

export interface IGetTipShare {
  name: string;
  contributors: string[];
  recipients: string[];
}

export enum IShareBasedOn {
  SALES = 'sales',
  TIPS = 'tips',
}

export const sourceFieldData = [
  { label: 'Card', value: 'card' },
  { label: 'Cash', value: 'cash' },
  { label: 'Tender', value: 'tender' },
  { label: 'Gift Card', value: 'gift_card' },
  { label: 'Gratuity', value: 'gratuity' },
];

export const thirdPartySourceFieldData = [
  { label: 'Door Dash', value: 'doordash' },
  { label: 'UberEats', value: 'uber-eats' },
  { label: 'Grub Hub', value: 'grub-hub' },
];

export const categoryFieldData = [
  { value: SaleCategory.FOOD_SALES, label: SaleCategory.FOOD_SALES },
  { value: SaleCategory.NON_ALCOHOLIC_BEVERAGE_SALES, label: SaleCategory.NON_ALCOHOLIC_BEVERAGE_SALES },
  { value: SaleCategory.BEER_SALES, label: SaleCategory.BEER_SALES },
  { value: SaleCategory.LIQUOR_SALES, label: SaleCategory.LIQUOR_SALES },
  { value: SaleCategory.WINE_SALES, label: SaleCategory.WINE_SALES },
  { value: SaleCategory.NON_FOOD_ITEMS, label: SaleCategory.NON_FOOD_ITEMS },
  { value: SaleCategory.COCKTAILS, label: SaleCategory.COCKTAILS },
  { value: SaleCategory.MOCKTAILS, label: SaleCategory.MOCKTAILS },
];

// ================ BACKEND TYPES ================

export enum ShareBasedOn {
  SALES = 'sales',
  TIPS = 'tips',
}

export enum TipConfigurationPaymentType {
  PAID_WITH_PAYCHECK = 'paid_with_paycheck',
  PAID_DAILY = 'paid_daily',
}

export enum TipShareTipPoolRoleType {
  CONTRIBUTOR = 'contributor',
  RECIPIENT = 'recipient',
}

export enum TipCalculationType {
  PERCENTAGE = 'percentage',
  POINTS = 'points',
  EQUALLY = 'equally',
}

export enum TipPoolRoleSourceType {
  GRATUITY = 'gratuity',
  CARD = 'card',
  CASH = 'cash',
  TENDER = 'tender',
  GIFT_CARD = 'gift_card',
  ONLINE = 'online',
  KIOSK = 'kiosk',
}

export enum EmployeeTipDistributionPaymentType {
  PAID = 'paid',
  UNPAID = 'unpaid',
  IN_PAYROLL = 'in_payroll',
}

export enum DailySalesTipCollectionTypeEnum {
  SALES = 'sales',
  TIP = 'tip',
}

export enum TipAuditLogDistributionLevel {
  ROLE = 'role',
  EMPLOYEE = 'employee',
}

export enum TipTableSource {
  GRATUITY = 'gratuity',
  CARD = 'card',
  CASH = 'cash',
  TENDER = 'tender',
  GIFT_CARD = 'gift_card',
  ONLINE = 'online',
  KIOSK = 'kiosk',
  QR = 'qr',
  THIRD_PARTY = 'third_party',
}

export enum DailySalesTipCollectionSourceType {
  GRATUITY = 'gratuity',
  CARD = 'card',
  CASH = 'cash',
  TENDER = 'tender',
  GIFT_CARD = 'gift_card',
  ONLINE = 'online',
  KIOSK = 'kiosk',
  SALES = 'sales',
}

export enum RoleTipDistributionType {
  SELF = 'self',
  DISTRIBUTE = 'distribute',
}
